import { createRouter, createWebHashHistory } from "vue-router";


const routes = [
  {
    path: "/",
    name: "main",
    redirect: "oauth",
    component: () => import("../views/orks/OutHee.vue"),
    children: [
      {
        path: "/emps",
        name: "emps",
        component: () => import("../views/orks/OrksEmp.vue"),
      },

      {
        path: "/HonorsList",
        name: "HonorsList",
        component: () => import("../views/aboutOur/HonorsList.vue"),
      },


      {
        path: "/SoftList",
        name: "SoftList",
        component: () => import("../views/aboutOur/SoftList.vue"),
      },
      {
        path: "/ProductModelQuery",
        name: "ProductModelQuery",
        component: () => import("../views/aboutOur/ProductModelQuery.vue"),
      },
      
    ],
  },
 
       {
    path: "/oauth",
    name: "oauth",
    // redirect: "",
    component: () => import("../views/orks/OauthTab.vue"),
      
      },

];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
